import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactFormComponent } from '../../../../shared/components/contact-form/contact-form.component';

@Component({
  selector: 'kt-app-contact-section',
  standalone: true,
  imports: [CommonModule, ContactFormComponent],
  templateUrl: './contact-section.component.html',
  styleUrl: './contact-section.component.scss'
})
export class ContactSectionComponent {
  
}
